export function formatAdded(added: string | string[]) {
    switch (added) {
        case '24_hours':
            return 'Added in the last 24 hours';
        case '3_days':
            return 'Added in the last 3 days';
        case '7_days':
            return 'Added in the last 7 days';
        case '14_days':
            return 'Added in the last 14 days';
        case '30_days':
            return 'Added in the last 30 days';
        default:
            return 'Added anytime';
    }
}
